import { CCol, CContainer, CRow } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import CensusCalender from './CensusCalender'
import DashboardHeader from './DashboardHeader'
import PracticeOverview from './PracticeOverview'
import ProviderHolds from './ProviderHolds/ProviderHolds'
import './Dashboard.scss'
import 'src/components/common/CardIssues/CardIssues.scss'
import { getCollector } from 'src/apiHelper/collectorApi'
import { useDispatch, useSelector } from 'react-redux'
import {
  getBetaVisitStatus,
  getFacilities,
  getVisitsCensus,
  getDischargeCodes,
} from 'src/redux/census/censusThunk'
import { format } from 'date-fns'
import ContactUs from './Components/ContactUS/ContactUs'
import PageHeader from 'src/components/common/PageHeader/PageHeader'
import { providerLogin, userSettingPut } from 'src/redux/user/userThunk'
import Loader from 'src/components/common/Loader/Loader'
import { getInitialProcedure } from 'src/redux/dashboard/dashboardThunk'
import { COLLECTOR_URL } from '../../../apiHelper/apiRoute/collector'
import InProgressQuickView from './InProgressQuickView/InProgressQuickView'
import { setActiveFacilityId } from '../../../redux/census/censusSlice'

// sort by last name, and if tie, sort by first name
function sortPatients(patients) {
  return [...patients].sort((a, b) => {
    const sortValue = (a.patient_lastname || '').localeCompare(b.patient_lastname || '')
    if (sortValue === 0) {
      return (a.patient_firstname || '').localeCompare(b.patient_firstname || '')
    }

    return sortValue
  })
}

export default function Dashboard() {
  const dispatch = useDispatch()
  const [providerHoldData, setProviderHoldData] = useState()
  const [issuesCount, setIssuesCount] = useState(0)
  const allFacilitiesList = useSelector((state) => state?.census?.allFacilitiesList) || []
  const activeTab =
    useSelector((state) => state?.census?.activeTab || state?.user?.settings?.censusFacilityID) ||
    localStorage.getItem('currentCensusFacilityId')

  const activeFacility = allFacilitiesList.find((item) => item._id === activeTab)

  const roles = useSelector((state) => state?.user?.roles)
  const provider = useSelector((state) => state?.user?.provider)
  const settings = useSelector((state) => state.user?.settings)

  const inPatients = useSelector((state) => state.census?.inPatients || [])
  let patients = sortPatients(inPatients)

  const isLoading = useSelector((state) => state.census?.isloading)
  const [isLoadingDashboard, setIsLoadingDashboard] = useState(false)

  const getProviderHoldData = async () => {
    const url = COLLECTOR_URL.GET_PROVIDER_HOLD_DATA
    let res = await getCollector(
      url.replace('{startIndex}', '0').replace('{recordCount}', '3').replace('{scope}', 'practice'),
    )
    if (res?.status === 'SUCCESS') {
      setProviderHoldData(res?.data.result)
      setIssuesCount(res?.data.total)
    }
  }

  useEffect(() => {
    if (
      (!activeTab || !allFacilitiesList.find((fac) => fac._id === activeTab)) &&
      allFacilitiesList?.[0]?._id
    ) {
      dispatch(setActiveFacilityId(allFacilitiesList[0]._id))
      if (Object.keys(settings || {})?.length > 2) {
        // arbitrary length, dont update unless settings are already pulled
        let newUserSettings = {
          ...settings,
          censusFacilityID: allFacilitiesList[0]._id,
        }
        dispatch(userSettingPut(newUserSettings))
      }
    }
  }, [dispatch, activeTab, allFacilitiesList])

  useEffect(() => {
    dispatch(getInitialProcedure())
    dispatch(getBetaVisitStatus())
    dispatch(getDischargeCodes())
  }, [dispatch])

  useEffect(() => {
    getProviderHoldData()
    dispatch(getFacilities())
  }, [dispatch, provider])

  useEffect(() => {
    if (activeFacility?._id) {
      dispatch(
        getVisitsCensus({
          servicedate: format(new Date(), 'yyyy-MM-dd'),
          thisProvider: provider,
          facility_id: activeFacility._id,
        }),
      )
    }
  }, [dispatch, provider, activeFacility?._id])

  const setSelectedprovider = async ({ practice_id, provider_id }) => {
    setIsLoadingDashboard(true)
    await dispatch(
      providerLogin({
        practice_id,
        provider_id,
      }),
    )
    await dispatch(getFacilities())
    await dispatch(
      getVisitsCensus({
        servicedate: format(new Date(), 'yyyy-MM-dd'),
        thisProvider: provider,
        facility_id: activeFacility?._id,
      }),
    )
    setIsLoadingDashboard(false)
  }

  return (
    <div className="dashboard-page">
      <CContainer>
        <PageHeader setSelectedProvider={setSelectedprovider} />
        <CContainer lg>
          {(isLoading || isLoadingDashboard) && <Loader />}

          <CRow>
            <CCol sm="12">
              <div className="header-holder">
                <DashboardHeader providerName={provider} />
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="9" md="12" lg="9">
              <div className="body-left">
                <CensusCalender
                  patients={patients}
                  selectedFacility={activeFacility}
                  allFacilitiesList={allFacilitiesList}
                />
                {roles?.find((role) => role === 'Claimocity Practice Owner') ? (
                  <PracticeOverview roles={roles} />
                ) : (
                  <div className="empty-practice-overview"></div>
                )}
              </div>
            </CCol>
            <CCol sm="3" md="3" lg="3">
              <div className="pt-4">
                <InProgressQuickView />
                <ProviderHolds providerHoldData={providerHoldData} issuesCount={issuesCount} />
                <ContactUs />
              </div>
            </CCol>
            <div className="app-footer">
              <span>© Claimocity, Inc. All Rights Reserved.</span>
            </div>
          </CRow>
        </CContainer>
      </CContainer>
    </div>
  )
}
